module.exports = __webpack_public_path__ + "img/ada-badge-2022_cn.38ff555.svg";